module.exports = __webpack_public_path__ + "static/media/proj1.3836f724.jpg";